export const getTaxLabel = (currencySymbol: string | undefined) => {
  const vatCurrencySymbols = ["€", "£"];

  if (currencySymbol && vatCurrencySymbols.includes(currencySymbol)) {
    return "VAT";
  }
  return "tax";
};
